import CallLogsDatatable from "../../components/CallLogsDatatable/CallLogsDatatable";


const CallLogs = () => {

  return (
    <>
      <CallLogsDatatable></CallLogsDatatable>
    </>
  );
};

export default CallLogs;
